<script lang="ts" setup>
  import { watchEffect } from 'vue';
  import { useServiceWorkerRegistration } from '@storefront/storefront';
  import { useHttpClient, useShared, useRoute } from '@othercommerce/foundation';

  const serviceWorker = useServiceWorkerRegistration();
  const route = useRoute();
  const http = useHttpClient();
  const shared = useShared();

  function urlBase64ToUint8Array(base64String: string) {
    let padding = '='.repeat((4 - base64String.length % 4) % 4);
    let base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

    let rawData = window.atob(base64);
    let outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }

    return outputArray;
  }

  watchEffect(() => {
    const worker = serviceWorker.value;
    const vapid = shared.value.appVapidPublicKey;

    if (worker && typeof window !== 'undefined' && 'Notification' in window && 'PushManager' in window && typeof Notification !== 'undefined' && typeof PushManager !== 'undefined' && vapid) {
      worker.pushManager.getSubscription().then(function (subscription) {
        if (!subscription) {
          Notification.requestPermission().then(function (result) {
            if (result === 'granted') {
              worker.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(vapid),
              }).then(function (subscription) {
                http.post(route('web.notifications.subscribe'), subscription).then(() => {
                  console.log('Subscribed to notifications!');
                }).catch((error) => {
                  // When error occurs when subscribing to the server we must
                  // unsubscribe. Since the server won't know about subscrition,
                  // thus it won't send any notifications to client.
                  subscription.unsubscribe();

                  console.error('Error subscribing to notifications:', error);
                });
              }).catch(function (error) {
                console.error('Error subscribing to notifications:', error);
              });
            } else {
              console.log('User has denied notification permission.');
            }
          }).catch(function (error) {
            console.error('Error requesting notification permission:', error);
          });
        } else {
          console.log('User is already subscribed to notifications.');
        }
      });
    }
  });
</script>
<template>
  <div class="notifications-controller" />
</template>
